import { TOC_TYPES } from '@openclassrooms/ui-web/table-of-content';
import { STATUSES } from '@openclassrooms/ui-web/learning-activities';
import type { PartType, CourseType } from '../types';

const isPartType = ({ type }: PartType) => type === TOC_TYPES.SUBTITLE || type === TOC_TYPES.MCQ;

const getNextPart = (flatToc: Array<PartType>): PartType | undefined => {
  const firstNotPassedPart = flatToc.find(
    (part) => isPartType(part) && part.learningActivityStatus !== STATUSES.STATUS_PASSED
  );

  const firstPart = flatToc.find(isPartType);

  return firstNotPassedPart || firstPart;
};

const getNextPartFromToc = (
  flatTableOfContent: Array<PartType>,
  course: CourseType
): PartType | undefined => {
  if (!course.nextChapterId) {
    return getNextPart(flatTableOfContent);
  }

  return flatTableOfContent.find(({ id }) => String(id) === course.nextChapterId);
};

export default getNextPartFromToc;
